<template>
  <router-view></router-view>
</template>

<script>
export default {}
</script>
<style>
@font-face {
  font-family: 'FS Magistral';
  src: url('./assets/font/FS Magistral-Light.ttf');
  font-weight: 300; /* bold */
  font-style: normal;
}
@font-face {
  font-family: 'FS Magistral';
  src: url('./assets/font/FS Magistral-Bold.ttf');
  font-weight: 700; /* bold */
  font-style: normal;
}
@font-face {
  font-family: 'FS Magistral';
  src: url('./assets/font/FS Magistral-Book.ttf');
  font-weight: 400; /* bold */
  font-style: normal;
}

@font-face {
  font-family: 'FS Magistral';
  src: url('./assets/font/FS Magistral-Medium.ttf');
  font-weight: 600; /* bold */
  font-style: normal;
}
</style>
